// extracted by mini-css-extract-plugin
export default {"sliderContenedor":"Carrusel_sliderContenedor__439uV","slider":"Carrusel_slider__1DEFO","item":"Carrusel_item__xUHwn","linkSerie":"Carrusel_linkSerie__imOVs"};